/*
* Event trigger
* Trigger a event
* @param {HTMLElement} el - Element 
* @param {string} event - event name to trigger
**/
export function emit (el, event, data = {}) {
    let x;
    if(typeof(Event) === 'function') {
        x = new CustomEvent(event, {
            detail: data
        });
    } else {
        x = document.createEvent('CustomEvent');
        x.initCustomEvent(event, true, true, data);
    }

    el.dispatchEvent(x);
}